import { FC } from "react";
import { useTranslation } from "@vixi/localization";
import { LangKey } from "@vixi/localization";

// Constants
const step_card_max_width = 339;

interface StepCardProps {
  stepNumber: number;
  title: LangKey;
  description?: LangKey;
}

const StepCard: FC<StepCardProps> = ({ stepNumber, title, description }) => {
  const { t, tNum } = useTranslation();

  return (
    <div
      className="bg-paper box-border flex h-34.5 w-full items-center justify-start rounded p-0"
      style={{ maxWidth: step_card_max_width }}
    >
      <div className="bg-paper flex h-full w-19.5 shrink-0 items-center rounded ps-6.25">
        <h4 className="text-primary-light fs-72 font-bold">{tNum(stepNumber)}</h4>
      </div>

      <div className="ps-4 pe-8">
        <h4 className="fs-21 font-bold">{t(title)}</h4>
        {description && <p className="fs-16 mt-2.5 font-normal">{t(description)}</p>}
      </div>
    </div>
  );
};

export default StepCard;
